import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sample-data"
export default class extends Controller {
  fillPersonalData(event) {
    const type = event.currentTarget.dataset.sampleType

    const sampleData = {
      john_doe: {
        applicant_first_name: 'John',
        applicant_last_name: 'Doe',
        applicant_email: 'john.doe@example.com',
        applicant_phone: '+12125551234',
        applicant_date_of_birth: '1985-03-15'
      },
      jane_smith: {
        applicant_first_name: 'Jane',
        applicant_last_name: 'Smith',
        applicant_email: 'jane.smith@restaurant.com',
        applicant_phone: '+13125559876',
        applicant_date_of_birth: '1978-08-22'
      }
    }

    const data = sampleData[type]
    if (data) {
      Object.entries(data).forEach(([field, value]) => {
        const input = document.querySelector(`[name="loan_application[${field}]"]`)
        if (input) {
          input.value = value
          input.dispatchEvent(new Event('input', { bubbles: true }))
          input.dispatchEvent(new Event('change', { bubbles: true }))
        }
      })
    }
  }

  fillBusinessData(event) {
    const type = event.currentTarget.dataset.sampleType

    const sampleData = {
      restaurant: {
        ein: '12-3456789',
        business_name: 'Downtown Bistro LLC',
        industry: 'Restaurant',
        years_in_business: '3.5',
        business_start_date: '2021-01-15',
        entity_type: 'llc',
        use_of_funds: 'expand_business',
        business_address: '123 Main Street',
        business_city: 'New York',
        business_state: 'NY',
        business_zip_code: '10001',
        liquor_license: true,
        seating_capacity: '75'
      },
      technology: {
        ein: '98-7654321',
        business_name: 'TechSolutions Inc',
        industry: 'Technology',
        years_in_business: '2',
        business_start_date: '2022-06-01',
        entity_type: 'c_corporation',
        use_of_funds: 'purchase_equipment',
        business_address: '456 Silicon Ave',
        business_city: 'San Francisco',
        business_state: 'CA',
        business_zip_code: '94105'
      }
    }

    const data = sampleData[type]
    if (data) {
      Object.entries(data).forEach(([field, value]) => {
        const input = document.querySelector(`[name="loan_application[${field}]"]`)
        if (input) {
          if (input.type === 'checkbox') {
            input.checked = value
          } else {
            input.value = value
          }
          input.dispatchEvent(new Event('input', { bubbles: true }))
          input.dispatchEvent(new Event('change', { bubbles: true }))
        }
      })

      // Populate the visible address autocomplete field
      if (data.business_address && data.business_city && data.business_state && data.business_zip_code) {
        const autocompleteInput = document.querySelector('#address_autocomplete')
        if (autocompleteInput) {
          autocompleteInput.value = `${data.business_address}, ${data.business_city}, ${data.business_state} ${data.business_zip_code}`
        }
      }
    }
  }
}
